// ============================================================================
// messaging — push do navegador via Firebase Cloud Messaging (FCM).
// ----------------------------------------------------------------------------
// - registerPushToken(uid): pede permissão, obtém o token FCM e salva em
//   users/{uid}.fcmTokens (arrayUnion). Sem a VAPID key configurada, faz no-op.
// - listenForegroundMessages(cb): mostra/encaminha mensagens com o app aberto.
//
// Requer REACT_APP_FIREBASE_VAPID_KEY (Console Firebase → Cloud Messaging →
// "Web Push certificates" → par de chaves). Sem ela, o sino in-app continua
// funcionando; só o push fica desativado.
// ============================================================================
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from "../firebaseConfig";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";

let messagingInstance = null;

const getMessagingIfSupported = async () => {
  if (messagingInstance) return messagingInstance;
  try {
    if (!(await isSupported())) return null;
    messagingInstance = getMessaging();
    return messagingInstance;
  } catch (e) {
    console.warn("FCM não suportado neste ambiente:", e);
    return null;
  }
};

// Pede permissão e registra o token FCM no documento do usuário.
export const registerPushToken = async (uid) => {
  if (!uid || !VAPID_KEY) return; // sem VAPID key → push desativado
  try {
    if (typeof Notification === "undefined") return;
    const messaging = await getMessagingIfSupported();
    if (!messaging) return;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;

    const swReg = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: swReg,
    });
    if (!token) return;

    await updateDoc(doc(db, "users", uid), {
      fcmTokens: arrayUnion(token),
    });
  } catch (err) {
    console.error("Erro ao registrar push token:", err);
  }
};

// Encaminha mensagens recebidas com o app em primeiro plano.
export const listenForegroundMessages = async (cb) => {
  const messaging = await getMessagingIfSupported();
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    try {
      cb?.(payload);
    } catch (e) {
      console.error("Erro no handler de mensagem:", e);
    }
  });
};
